import { type RovoInstrumentedError } from '@atlassian/conversation-assistant-utils/httpUtils';

import { generateTraceId } from './generateTraceId';

/**
 * Error thrown when a stream needs to be reconnected due to a client-side streaming error.
 * This signals that the reconnectToInProgressStream action should be triggered.
 */
export class StreamDisconnectedError extends Error implements RovoInstrumentedError {
	errorAttributes: RovoInstrumentedError['errorAttributes'];

	readonly agentMessageId: string;
	readonly conversationId: string;
	readonly answerIndex: number;
	readonly lastEventId?: string;

	constructor(
		message: string,
		params: {
			agentMessageId: string;
			conversationId: string;
			answerIndex: number;
			lastEventId?: string;
			originalError: Error;
			traceId?: string;
			detail?: {
				millisOffset?: number;
				type: string;
			};
		},
	) {
		super(message);
		this.name = this.constructor.name;

		this.agentMessageId = params.agentMessageId;
		this.conversationId = params.conversationId;
		this.answerIndex = params.answerIndex;
		this.lastEventId = params.lastEventId;

		this.errorAttributes = {
			traceId: params.traceId ?? `StreamReconnection-${generateTraceId()}`,
			errorCode: 'STREAM_RECONNECTION_NEEDED',
			originalError: params.originalError.message,
			latestStreamMessageType: params.detail?.type,
			latestStreamMessageMillisOffset: params.detail?.millisOffset,
		};

		if (typeof Error.captureStackTrace === 'function') {
			Error.captureStackTrace(this, this.constructor);
		}
	}
}
